<template>
  <div class="dy-viewer">
    <div class="dy-phone">
      <div class="dy-stage">
        <video
          v-if="item.videoUrl"
          class="dy-media"
          :src="item.videoUrl"
          :poster="item.coverUrl || undefined"
          controls
          playsinline
          loop
        />
        <img
          v-else-if="item.coverUrl"
          class="dy-media"
          :src="item.coverUrl"
          alt=""
          referrerpolicy="no-referrer"
        />
        <div v-else class="dy-empty">暂无画面</div>

        <div class="dy-side">
          <div class="dy-avatar">
            <img v-if="item.authorAvatar" :src="item.authorAvatar" alt="" referrerpolicy="no-referrer" />
            <span v-else>{{ (item.authorName || '?')[0] }}</span>
          </div>
          <div class="dy-action">
            <span class="dy-ico">♥</span>
            <small>{{ formatCount(item.likes) }}</small>
          </div>
          <div class="dy-action">
            <span class="dy-ico">💬</span>
            <small>{{ formatCount(item.comments) }}</small>
          </div>
          <div class="dy-action">
            <span class="dy-ico">★</span>
            <small>{{ formatCount(item.collects) }}</small>
          </div>
          <div class="dy-action">
            <span class="dy-ico">↗</span>
            <small>{{ formatCount(item.shares) }}</small>
          </div>
        </div>

        <div class="dy-caption">
          <div class="dy-name">@{{ item.authorName || '创作者' }}</div>
          <div class="dy-text">{{ item.content || item.title }}</div>
          <div v-if="item.views" class="dy-views">播放 {{ formatCount(item.views) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { formatCount } from './normalizeContent'

defineProps({
  item: { type: Object, required: true },
})
</script>

<style scoped>
.dy-viewer {
  display: flex;
  justify-content: center;
  padding: 8px 0 4px;
  background: radial-gradient(ellipse at top, #2a2e36 0%, #121418 55%);
}
.dy-phone {
  width: min(320px, 100%);
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);
  border: 1px solid #2c313a;
}
.dy-stage {
  position: relative;
  aspect-ratio: 9 / 16;
  background: #000;
}
.dy-media {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background: #000;
}
.dy-empty {
  height: 100%;
  display: grid;
  place-items: center;
  color: #777;
}
.dy-side {
  position: absolute;
  right: 10px;
  bottom: 110px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  color: #fff;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.45);
}
.dy-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #fff;
  background: #333;
  display: grid;
  place-items: center;
  font-weight: 700;
  margin-bottom: 4px;
}
.dy-avatar img { width: 100%; height: 100%; object-fit: cover; }
.dy-action {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}
.dy-ico { font-size: 22px; line-height: 1; }
.dy-action small { font-size: 11px; }
.dy-caption {
  position: absolute;
  left: 12px;
  right: 64px;
  bottom: 18px;
  color: #fff;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.55);
}
.dy-name { font-weight: 700; font-size: 14px; margin-bottom: 6px; }
.dy-text {
  font-size: 13px;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: pre-wrap;
}
.dy-views { margin-top: 8px; font-size: 11px; opacity: 0.85; }
</style>
